export default "__VITE_ASSET__06b3b836__"